module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAUVBMVEUAAACDg4OIiIiIiIiIiIiIiIiHh4eJiYmIiIiIiIiIiIiJiYmIiIidnZ2IiIiJiYmJiYmJiYmJiYmHh4eJiYmIiIiHh4eSkpKJiYmMjIyIiIghvk+LAAAAGnRSTlMAC7qxk4NmUMShmY1sBPe1qXx4c15YQwdbH2w7JNwAAACBSURBVEjH7dJJEoMwEARBCWzAYPZ9/v9QWk9QHThN3TN6IqTgeV5W3w90Zkx2ZtbBSbrJ5SLZIjlL/l7eXNMmlhOS/7SJZRmpLJCsJBvg+hZ+20luzmfnKFeBO0vmTuhiIbeBO0fmYiN3wTv399ytO4c65JfegbhwDMxJ1sHzPNoD1GYKV55zzSwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rem/rightjt.png
// module id = lAFA
// module chunks = 14